import React, { Component } from "react";
import dataJSON from "../../static/sliderData.json";
import Slider from "../Helpers/Slider/Slider";
import Popup from "../Popup/Popup";
import PopupMain from "../Popup/PopupMain";
import "./Carousel.scss";
import PopupInfo from "../Popup/PopupInfo.jsx";

const throwPopupEvent = (obj) => {
    window.dispatchEvent(new CustomEvent("showpopup", {
        "detail": obj
    }));
}

const InnerItem = props => {

    return (
        <div className={`item image-${props.id}`} onClick={() => {
            throwPopupEvent({
                Type: "Message",
                ClassName: "success",
                Component: <PopupInfo {...props} />
            });
        }}>
            <div className="text">
                <div className="name">{props.name}</div>
                <div className="country">{props.country}</div>
            </div>
        </div>


    )
}
export default class Carousel extends Component {
    constructor() {
        super();
        this.setOwlRef = this.setOwlRef.bind(this);
        this.handlePopUp = this.handlePopUp.bind(this);
        this.state = {
            OwlRef: null
        }
    }
    handlePopUp(item) {
        // console.log(item);
    }

    renderMovies() {
        return dataJSON.map((item, index) => <InnerItem key={index} index={index} {...item} onClick={this.handlePopUp(...item)} />)
    }
    setOwlRef(ref) {
        this.setState({
            OwlRef: ref
        })
    }

    render() {
        return (
            <div className="section section-slider">
                <div className="padding">
                    <div className="container">
                        <div className="slider">
                            <Slider
                                changeListener={this.changeListener}
                                setOwlRef={this.setOwlRef}>
                                {this.renderMovies()}
                            </Slider>
                            <div
                                ref={arrowLeft => this.arrowLeft = arrowLeft}
                                onClick={() => {
                                    this.state.OwlRef != null ? this.state.OwlRef.prev(600) : null
                                }} className={`arrow right`}></div>
                            <div
                                ref={arrowRight => this.arrowRight = arrowRight}
                                onClick={() => {
                                    this.state.OwlRef != null ? this.state.OwlRef.next(600) : null
                                }} className={`arrow left`}></div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/Components/Form/Carousel.jsx